// /src/pages/Login.tsx
import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  FormControl,
  FormLabel,
  Heading,
  Input,
  VStack,
  Text,
  useToast,
  Card,
  CardBody,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const success = login(email, password);
    
    if (success) {
      toast({
        title: 'Inicio de sesión exitoso',
        status: 'success',
        duration: 2000,
      });
      navigate('/admin/dashboard');
    } else {
      toast({
        title: 'Error de autenticación',
        description: 'Email no encontrado',
        status: 'error',
        duration: 3000,
      });
    }
  };

  return (
    <Box bg="gray.50" minH="100vh" display="flex" alignItems="center" justifyContent="center">
      <Container maxW="md">
        <Card>
          <CardBody>
            <VStack spacing={6} align="stretch">
              <Box textAlign="center">
                <Heading size="xl" color="blue.600" mb={2}>
                  CertificaPro
                </Heading>
                <Text color="gray.600">
                  Sistema de Gestión de Certificaciones
                </Text>
              </Box>

              <form onSubmit={handleSubmit}>
                <VStack spacing={4}>
                  <FormControl isRequired>
                    <FormLabel>Correo Electrónico</FormLabel>
                    <Input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="usuario@ejemplo.com"
                    />
                  </FormControl>

                  <FormControl isRequired>
                    <FormLabel>Contraseña</FormLabel>
                    <Input
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="••••••••"
                    />
                  </FormControl>

                  <Button type="submit" colorScheme="blue" w="full" size="lg">
                    Iniciar Sesión
                  </Button>
                </VStack>
              </form>

              <Box bg="blue.50" p={4} borderRadius="md">
                <Text fontSize="sm" fontWeight="bold" mb={2}>
                  Usuarios de prueba:
                </Text>
                <Text fontSize="xs" color="gray.700">
                  • Admin: admin@certificapro.com
                </Text>
                <Text fontSize="xs" color="gray.700">
                  • Consultor: consultor@certificapro.com
                </Text>
                <Text fontSize="xs" color="gray.700">
                  • Cliente: cliente@empresa1.com
                </Text>
              </Box>
            </VStack>
          </CardBody>
        </Card>
      </Container>
    </Box>
  );
};
